<div class="flex h-screen overflow-hidden">
  <!-- Sidebar -->
  <app-sidebar [menuItems]="menuItems"></app-sidebar>
  <!-- Main Content Area -->
  <main class="flex-1 transition-all duration-300 min-h-screen flex flex-col">
        <!-- Fixed Breadcrumb at Top -->
    <div class="sticky top-0 z-[500] w-full shadow-sm flex-shrink-0">
      <div class="px-6 py-4 flex items-center justify-between">
        <app-breadcrumb [breadcrumbs]="breadcrumbs" [parentRoute]="parentRoute"></app-breadcrumb>
      </div>
    </div>


    <!-- Scrollable Content -->
    <div class="flex-1 p-6 overflow-y-auto min-h-0">
      <ng-content></ng-content>
      <router-outlet></router-outlet>
    </div>
  </main>
</div>
